//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Colorable from "../../mixins/Colorable";
import Sizeable from "../../mixins/Sizeable";
import Linkable from "../../mixins/Linkable";
import Icon from "../Icon/Icon";
import {formatDimension} from "../../helpers/format_helpers";
const CdnImage = () => import("../../components/Image/CdnImage");
const Tooltip = () => import("../../components/Tooltip/Tooltip");
export default {
    name: "Chip",
    components: {CdnImage, Icon, Tooltip},
    mixins: [Colorable, Sizeable, Linkable],

    props: {
        // An icon to display as prefix on the chip
        icon: {
            type: String,
            default: null
        },

        // Whether a close icon shall be displayed
        close: {
            type: Boolean,
            default: false
        },

        // A help text to show within a help tooltip
        help: {
            type: String,
            default: null
        },

        maxWidth: {
            type: [String, Number],
            default: null
        },
    },

    computed: {
        hasActiveState() {
            return !this.disabled && (this.isActive || this.hasActiveTo)
        },

        tag() {
            if (this.absoluteTo) {
                return 'a';
            }
            if (this.relativeTo) {
                return 'nuxt-link';
            }

            return 'span';
        },

        style() {
            const style = {};

            if (this.colorHex) {
                style.backgroundColor = this.colorHex;
            }

            if (this.maxWidth) {
                style.maxWidth = formatDimension(this.maxWidth)
            }

            return style;
        },

        isClickable() {
            return this.isClickable || this.tag !== 'span';
        },

        iconSize() {
            switch (this.sizeString) {
                case '2xs':
                    return 8;
                case 'xs':
                    return 9;
                case 'sm':
                    return 12;
                case 'lg':
                    return 18;
                case 'xl':
                    return 20;
                case '2xl':
                    return 22;
            }

            return 16;
        }
    }
}
